import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-124c6577"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "h"
  }, null, -1);
});
var _hoisted_2 = {
  "class": "lotteryMain"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "navbox"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "nav"
  }, [/*#__PURE__*/_createElementVNode("span", null, "開獎公告")])], -1);
});
var _hoisted_4 = {
  "class": "sub-nav"
};
var _hoisted_5 = {
  key: 0,
  "data-v-dcdb1798": "",
  "class": "hot"
};
var _hoisted_6 = {
  "class": "main-page-full"
};
import hisWrapper from '@/components/hisWrapper.vue';
import { record } from '@/utils/https.js';
import plaues from '@/components/playes.vue';
import { reactive } from 'vue';
import axios from "axios"; //原生的axios

export default {
  __name: 'post',
  setup: function setup(__props) {
    var t = new Date().getTime();
    var tow = function tow(n) {
      return n >= 0 && n < 10 ? '0' + n : '' + n;
    };
    var toLink = reactive([{
      name: '澳門六合彩',
      path: '/post'
    }, {
      name: '接口調用',
      path: '/post/api'
    }
    //  {name:'資料區',path:'/post'},
    ]);

    var videoShow = ref(false);
    var codeArray = reactive({});
    var pclose = function pclose(e) {
      videoShow.value = e;
    };
    var videoBack = function videoBack(e) {
      videoShow.value = true;
      codeArray = e;
    };
    var fiveArray = reactive([]);
    var fivedata = ref([]);
    var newCode = ref({});
    var kajing = reactive([]);
    var period = ref('');
    var hours = ref([0, 0]);
    var minutes = ref([0, 0]);
    var seconds = ref([0, 0]);

    //简体字转繁体字
    var textChange = function textChange(n) {
      var jt = "龙马鸡猪";
      var ft = "龍馬雞豬";
      if (jt.indexOf(n) == -1) {
        return n;
      } else {
        var r = ft.substr(jt.indexOf(n), 1);
        return r;
      }
      return n;
    };
    setInterval(function () {
      getDate();
    }, 1000);
    var getDate = function getDate() {
      var oDate = new Date(); //获取日期对象
      var oldTime = oDate.getTime(); //现在距离1970年的毫秒数
      var tive = newCode.value.Year + '/' + newCode.value.Moon + '/' + newCode.value.Day + ' ' + newCode.value.Time + ':00';
      var newDate = new Date(tive);
      var newTime = newDate.getTime(); //2019年距离1970年的毫秒数
      var second = Math.floor((newTime - oldTime) / 1000); //未来时间距离现在的秒数
      var hour = Math.floor(second / 3600); //整数部分代表小时；
      second %= 3600; //余数代表 剩下的秒数；
      var minute = Math.floor(second / 60);
      second %= 60;
      hours.value = tow(hour).split('');
      minutes.value = tow(minute).split('');
      seconds.value = tow(second).split('');
    };
    // onBeforeMount(()=>{
    //     let url1 = "https://kj6.kkjj.finance/data/v_"+process.env.VUE_APP_TYPE_NAME+".json?"+t;
    //     axios(url1).then((res)=>{
    //         let data = res.data
    //         data.Time= data.Time.replace('点',':').replace('分','');
    //         for(var i = 1; i<=7;i++){

    //             kajing.push(data.Data[i])
    //         }
    //         newCode.value = data;
    //     })

    //     records()
    // })
    var activeIndex = ref(1);
    var newYear = function newYear(e) {
      activeIndex.value = e;
      var s = newCode.value.Year - 1 + '/01/01 00:00:00';
      var t = newCode.value.Year - 1 + '/12/31 00:00:00';
      records(s, t, '');
      console.log(s, t);
    };
    var oldYear = function oldYear(e) {
      activeIndex.value = e;
      console.log();
      var s = newCode.value.Year + '/01/01 00:00:00';
      var t = newCode.value.Year + '/' + newCode.value.Moon + '/' + newCode.value.Day + ' ' + newCode.value.Time + ':' + '00';
      records(s, t, '');
      console.log(s, t);
    };
    var inputFunc = function inputFunc(e) {
      console.log(period);
      records('', '', period.value);
      fiveArray = [];
    };
    var records = function records() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      record({
        lottery_id: process.env.VUE_APP_TYPE_CODE,
        start_time: start,
        end_time: end,
        periods: period
      }).then(function (res) {
        var data = res.data.data;
        if (data.length == 0) {
          fiveArray.length = [];
        } else {
          fiveArray.length = [];
          fivedata.value = data[0];
          data.forEach(function (item, i) {
            fiveArray.push(item);
          });
          fiveArray.forEach(function (items) {
            items.open_number = items.open_number.split(',');
            items.sx = items.sx.split(',');
            items.color = items.color.split(',');
          });
        }
      });
    };
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("nav", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toLink, function (item, index) {
        return _openBlock(), _createBlock(_component_router_link, {
          to: {
            path: item.path
          },
          key: index,
          "active-class": "router-link-exact-active"
        }, {
          "default": _withCtx(function () {
            return [_createElementVNode("span", null, _toDisplayString(item.name), 1), index == 2 ? (_openBlock(), _createElementBlock("sup", _hoisted_5, "hot")) : _createCommentVNode("", true)];
          }),
          _: 2
        }, 1032, ["to"]);
      }), 128))])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view)])]), _createVNode(plaues, {
        videoShow: _unref(videoShow),
        onPclose: _unref(pclose),
        codeArray: _unref(codeArray)
      }, null, 8, ["videoShow", "onPclose", "codeArray"])], 64);
    };
  }
};